module.exports = __webpack_public_path__ + "images/newerp_logo_w.1788773129009.png";